import { useCallback } from 'react';
import { useMutation, gql } from '@apollo/client';
import emptyFunction from 'react-utils/emptyFunction';
const UPDATE_ACTIVITY_BUTTONS = ("__gql__", "{\"kind\":\"Document\",\"definitions\":[{\"kind\":\"OperationDefinition\",\"operation\":\"mutation\",\"name\":{\"kind\":\"Name\",\"value\":\"updateActivityButtons\"},\"variableDefinitions\":[{\"kind\":\"VariableDefinition\",\"variable\":{\"kind\":\"Variable\",\"name\":{\"kind\":\"Name\",\"value\":\"input\"}},\"type\":{\"kind\":\"NonNullType\",\"type\":{\"kind\":\"NamedType\",\"name\":{\"kind\":\"Name\",\"value\":\"UpdateActivityButtonsInput\"}}}}],\"selectionSet\":{\"kind\":\"SelectionSet\",\"selections\":[{\"kind\":\"Field\",\"name\":{\"kind\":\"Name\",\"value\":\"updateActivityButtons\"},\"arguments\":[{\"kind\":\"Argument\",\"name\":{\"kind\":\"Name\",\"value\":\"input\"},\"value\":{\"kind\":\"Variable\",\"name\":{\"kind\":\"Name\",\"value\":\"input\"}}}],\"selectionSet\":{\"kind\":\"SelectionSet\",\"selections\":[{\"kind\":\"Field\",\"name\":{\"kind\":\"Name\",\"value\":\"name\"}}]}}]}}]}", {
  id: null,
  kind: "Document",
  definitions: [{
    kind: "OperationDefinition",
    operation: "mutation",
    name: {
      kind: "Name",
      value: "updateActivityButtons"
    },
    variableDefinitions: [{
      kind: "VariableDefinition",
      variable: {
        kind: "Variable",
        name: {
          kind: "Name",
          value: "input"
        }
      },
      type: {
        kind: "NonNullType",
        type: {
          kind: "NamedType",
          name: {
            kind: "Name",
            value: "UpdateActivityButtonsInput"
          }
        }
      }
    }],
    selectionSet: {
      kind: "SelectionSet",
      selections: [{
        kind: "Field",
        name: {
          kind: "Name",
          value: "updateActivityButtons"
        },
        arguments: [{
          kind: "Argument",
          name: {
            kind: "Name",
            value: "input"
          },
          value: {
            kind: "Variable",
            name: {
              kind: "Name",
              value: "input"
            }
          }
        }],
        selectionSet: {
          kind: "SelectionSet",
          selections: [{
            kind: "Field",
            name: {
              kind: "Name",
              value: "name"
            }
          }]
        }
      }]
    }
  }]
});
const _updateCachedSelectedActivityButtons = ({
  newActivityButtons,
  updateQuery
}) => {
  updateQuery(cachedButtonData => {
    // create a map of button names -> button ids to get the selected button ids
    const buttonIdMap = cachedButtonData.crmObject.allActivityButtons.reduce((acc, button) => acc.set(button.name, button.id), new Map());
    const selectedActivityButtons = newActivityButtons.map(selectedButton => ({
      name: selectedButton.name,
      id: buttonIdMap.get(selectedButton.name),
      __typename: 'ActivityButton'
    }));
    return {
      crmObject: Object.assign({}, cachedButtonData.crmObject, {
        selectedActivityButtons
      })
    };
  });
};
export const useUpdateActivityButtons = ({
  updateQuery
}) => {
  const [updateActivityButtons] = useMutation(UPDATE_ACTIVITY_BUTTONS);
  return useCallback(selectedActivityButtons => {
    const selectedActivityButtonsArray = selectedActivityButtons.map(name => ({
      name
    }));
    updateActivityButtons({
      variables: {
        input: {
          activityButtons: selectedActivityButtonsArray
        }
      }
    }).catch(emptyFunction);
    _updateCachedSelectedActivityButtons({
      newActivityButtons: selectedActivityButtonsArray,
      updateQuery
    });
  }, [updateQuery, updateActivityButtons]);
};